<era-panel>
  <era-panel-header>
    <era-title-h4>
      <h5 class="small-caps text-primary"
          i18n>{{ headerLabel() }}</h5>
      <era-context-menu [isEditing]="editEnabled"
                        (selectedEdit)="toggleEditPresets()"
                        canEdit="true">
        <a ngbDropdownItem
           [routerLink]="['add']">Add</a>
      </era-context-menu>
    </era-title-h4>
  </era-panel-header>

  <ml-sk-spinner-3 [hidden]="!!presets()"></ml-sk-spinner-3>
  <div class="list-group list-group-flush">
    @for (preset of presets(); track preset.uniqueId ?? preset.id) {
      <ml-mdm-settings-profile-preset-list-item (deleted)="deletePreset.emit($event)"
                                                [preset]="preset"
                                                [profileType]="profileType()"
                                                [displayField]="getDisplayField()"
                                                [allowDelete]="editEnabled">
      </ml-mdm-settings-profile-preset-list-item>
    }
  </div>
</era-panel>